import { CREATE_ROLE, DELETE_ROLE, GET_PERMISSION, GET_USERS_WITH_ROLES, MANAGE_ROLE, UPDATE_ROLE } from './redux.actionTypes';

export const createRole = ({ handleComplete, ...payload }) => ({
    type: CREATE_ROLE,
    meta: { handleComplete },
    payload,
});

export const updateRole = ({ handleComplete, ...payload }) => ({
    type: UPDATE_ROLE,
    meta: { handleComplete },
    payload,
});

export const getPermission = ({ handleSubmit, ...payload }) => ({
    type: GET_PERMISSION,
    meta: { handleSubmit },
    payload,
});

export const deleteRole = ({ handleSubmit, payload }) => ({
    type: DELETE_ROLE,
    meta: { handleSubmit },
    payload,
});

/**
 * Assign or revoke a role for a user.
 * @param {string}   email        - Target user's email
 * @param {string}   roleName     - Role to add/remove
 * @param {'add'|'remove'} action - Operation type
 * @param {Function} handleComplete - Called with (null | Error) on finish
 */
export const manageRole = ({ email, roleName, action, handleComplete }) => ({
    type: MANAGE_ROLE,
    meta: { handleComplete: handleComplete ?? (() => {}) },
    payload: { email, roleName, action },
});

/**
 * Fetch paginated users with their assigned roles.
 * @param {object}   params        - { limit, offset, roleName, search }
 * @param {Function} handleComplete - Called with ({ data, total } | Error) on finish
 */
export const getUsersWithRoles = ({ handleComplete, ...params }) => ({
    type: GET_USERS_WITH_ROLES,
    meta: { handleComplete: handleComplete ?? (() => {}) },
    payload: params,
});
